export default __webpack_public_path__ + "static/Montserrat-Regular-e4a49fd341ee7dfe85d6da743667ba67.ttf";